import {AvailabilityGroupStepController} from './stepGroups/availability';
import {CareerGoalsGroupStepController} from './stepGroups/careerGoals';
import {CompleteGroupStepController} from './stepGroups/complete';
import {ConfirmGroupStepController} from './stepGroups/confirm';
import {ControllersModule} from 'controllers/module';
import {GettingStartedGroupStepController} from './stepGroups/gettingStarted';
import {MatchingController} from './matching';
import {PersonalInfoGroupStepController} from './stepGroups/personalInfo';
import {ProfessionalInfoGroupStepController} from './stepGroups/professionalInfo';
import {RegistrationController} from './registration';
import {VerifyEmailStepController} from './stepGroups/verifyEmail';
import {NewProgramAddedGroupStepController} from './stepGroups/newProgramAdded';

export default ControllersModule.
    controller('RegistrationController', RegistrationController).
    controller('MatchingController', MatchingController).
    controller('GroupStep_GettingStarted', GettingStartedGroupStepController).
    controller('GroupStep_VerifyEmail', VerifyEmailStepController).
    controller('GroupStep_NewProgramAdded', NewProgramAddedGroupStepController).
    controller('GroupStep_PersonalInfo', PersonalInfoGroupStepController).
    controller('GroupStep_ProfessionalInfo', ProfessionalInfoGroupStepController).
    controller('GroupStep_CareerGoals', CareerGoalsGroupStepController).
    controller('GroupStep_Availability', AvailabilityGroupStepController).
    controller('GroupStep_Confirm', ConfirmGroupStepController).
    controller('GroupStep_Complete', CompleteGroupStepController);
